// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const invManufacturerId = (z.number());
export const invManufacturer = z.object({
    id: invManufacturerId,
    name: z.string(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invManufacturerInitializer = z.object({
    id: invManufacturerId.optional(),
    name: z.string(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invManufacturerMutator = z.object({
    id: invManufacturerId.optional(),
    name: z.string().optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvManufacturer.js.map